import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_edit",
  "use": "svg_edit-usage",
  "viewBox": "0 0 23 23",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 23\" id=\"svg_edit\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22.205 5.25 17.793.839 3.424 15.206l-2.758 7.17 7.17-2.757L22.207 5.25Zm-7.298.88 2.886-2.885 2.005 2.006-2.885 2.885-2.006-2.006Zm-1.203 1.204-8.821 8.82-1.254 3.26 3.26-1.254 8.82-8.82-2.005-2.006Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol